import { render, staticRenderFns } from "./judge-registration-print.vue?vue&type=template&id=590d35d3&scoped=true&"
import script from "./judge-registration-print.vue?vue&type=script&lang=js&"
export * from "./judge-registration-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d35d3",
  null
  
)

export default component.exports